'use client';

import ArticleDetail from '@/components/article-detail';
import { ContactBreadcrumbItems } from '@/data/globals.data';
import { ApiResponse } from '@/services/base-api';
import { ArticleEntity } from '@/services/types/article.type';

export default function Client({
  initialData,
}: {
  initialData?: ApiResponse<ArticleEntity>;
}) {
  return (
    <ArticleDetail
      breadcrumbItems={ContactBreadcrumbItems}
      initialData={initialData}
    />
  );
}
